import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { readCoachSessionUpdates,sessionRpc,type CoachSessionUpdate } from '@/lib/coachSessionFollowThrough';

export function useCoachSessionUpdates(coachId?:string){
  const {user}=useAuth();const queryClient=useQueryClient();const actor=coachId??user?.id;
  const query=useQuery({queryKey:['coach-session-updates',actor],enabled:Boolean(actor&&user?.id===actor),retry:false,refetchInterval:60_000,staleTime:0,
    queryFn:async()=>readCoachSessionUpdates(await sessionRpc('list_coach_session_updates_v1',{p_limit:10}))});
  const updates=actor===user?.id&&!query.isFetching&&!query.isError?query.data??[]:[];
  const acknowledge=async(update:CoachSessionUpdate)=>{
    if(actor!==user?.id)throw new Error('Session updates are unavailable.');
    const confirmed=await sessionRpc('ack_coach_session_update_v1',{p_record_id:update.recordId,p_publication_id:update.publicationId,p_kind:update.kind,p_item_id:update.itemId,p_agreement_digest:update.agreementDigest,p_expected_revision:update.revision,p_relationship_revision:update.relationshipRevision});
    if(typeof confirmed!=='boolean')throw new Error('The update acknowledgement could not be confirmed.');
    await queryClient.invalidateQueries({queryKey:['coach-session-updates',actor]});return confirmed;
  };
  return {...query,updates,acknowledge};
}
